import { request } from '@/shared/api/request'

export const findKatoByCode = (params) => {
	return request({ url: 'dict/findKatoByCode', method: 'GET', params })
}
